export const CORREOS_DE_CHILE_CARRIER = "60503000";

// "*" en la lista habilita el piloto para todas las tiendas; sacarlo de la config lo revierte.
export const ALL_STORES = "*";

export function isCorreosPilotStore(permittedStores: string[] | undefined, storeCode?: string | number | null): boolean {
  if (permittedStores?.includes(ALL_STORES)) return true;
  return permittedStores?.includes(String(storeCode ?? "").trim()) ?? false;
}

// Piloto de los selectores de transportista: tienda piloto Y usuario admin (permiso ADMIN_ALL).
export function isCorreosPilotUser(permittedStores: string[] | undefined, storeCode: string | number | null | undefined, isAdmin: boolean): boolean {
  return isAdmin && isCorreosPilotStore(permittedStores, storeCode);
}

// El modulo Etiquetas (/labels: etiquetas y manifiestos) se oculta a todos los perfiles de una tienda piloto.
export function isLabelsMenuHiddenForUser(permittedStores: string[] | undefined, storeCode: string | number | null | undefined): boolean {
  return isCorreosPilotStore(permittedStores, storeCode);
}

// Recibe los transportistas ya filtrados por tipo de garantia.
// Piloto: solo Correos de Chile; si Correos no esta disponible para esa garantia, lista intacta para no dejar el selector vacio.
// No piloto: lista tal cual la entrega ost_params (Correos de Chile ya se ofrece en todas las garantias).
export function filterCarriersByStore<T extends { valorParametro: string }>(carriers: T[], isPilotStore: boolean): T[] {
  if (!isPilotStore) return carriers;
  const correos = carriers.filter((carrier: T) => carrier.valorParametro === CORREOS_DE_CHILE_CARRIER);
  return correos.length > 0 ? correos : carriers;
}
